import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiSaveIcon from '@material-ui/icons/Save';
import MuiDeleteIcon from '@material-ui/icons/Delete';
import MuiEditIcon from '@material-ui/icons/Edit';
import MuiCancelIcon from '@material-ui/icons/Cancel';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';

import MuiCircularProgress from '@material-ui/core/CircularProgress';

import { WithTooltip } from 'utils/wrappers';

const styles = () => ({
  hiddenButton: {
    visibility: 'hidden',
    width: 40,
  },
});

const RowButtons = props => {
  const {
    isEditingRow,
    isLoadingSubmit,
    handleCancelClick,
    handleDeleteClick,
    handleEditClick,
    handleSaveClick,
    handleActAsClick,
    row,
  } = props;
  // Components

  const ActionInProgress = (
    <MuiIconButton disabled={true}>
      <MuiCircularProgress size={'1rem'} />
    </MuiIconButton>
  );

  const ButtonSaveRowEdit = (
    <WithTooltip tooltip="Save Changes">
      <MuiIconButton type="submit" onClick={handleSaveClick}>
        <MuiSaveIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ButtonCancelRowEdit = (
    <WithTooltip tooltip="Cancel">
      <MuiIconButton onClick={handleCancelClick}>
        <MuiCancelIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ButtonDeleteUser = !row?.accepted_terms_at && (
    <WithTooltip tooltip="Delete User">
      <MuiIconButton onClick={handleDeleteClick}>
        <MuiDeleteIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ButtonToggleRowEdit = (
    <WithTooltip tooltip="Edit User">
      <MuiIconButton onClick={handleEditClick}>
        <MuiEditIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ButtonActAsUser = (
    <WithTooltip tooltip="Act As User">
      <MuiIconButton onClick={handleActAsClick}>
        <EmojiEmotionsIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  if (isLoadingSubmit) {
    return ActionInProgress;
  }

  if (isEditingRow) {
    return (
      <>
        {ButtonSaveRowEdit}
        {ButtonCancelRowEdit}
      </>
    );
  }

  return (
    <>
      {ButtonActAsUser}
      {ButtonDeleteUser}
      {ButtonToggleRowEdit}
    </>
  );
};

export default withStyles(styles)(RowButtons);
